import React, { createContext, useState, useEffect } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [companyId, setCompanyId] = useState(() => {
    // Legge solo una volta all'avvio
    return localStorage.getItem("companyId") || "TOPRUOTE";
  });

  useEffect(() => {
    const saved = localStorage.getItem("companyId");
    // 🔹 Se il valore è diverso da quello salvato, allora aggiorna e ricarica
    if (saved !== companyId) {
      localStorage.setItem("companyId", companyId);
      // Usa un piccolo delay per evitare che React si blocchi durante il render
      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
  }, [companyId]);

  return (
    <AppContext.Provider value={{ companyId, setCompanyId }}>
      {children}
    </AppContext.Provider>
  );
};
